import { Component, computed, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { ServiceProvidersService } from '../../services/service-providers-service';
import { ServiceProviderType } from '../../../../core/api/mhsConfigurationApiClient';

@Component({
  selector: 'app-service-provider-details',
  imports: [
    CommonModule,
    NzCardModule,
    NzTagModule,
    NzIconModule,
    NzButtonModule,
    NzSpinComponent,
    RouterLink,
  ],
  templateUrl: './service-provider-details.html',
  styleUrl: './service-provider-details.scss',
})
export class ServiceProviderDetailsComponent {
  private route = inject(ActivatedRoute);
  private service = inject(ServiceProvidersService);

  readonly serviceProviderId = Number(this.route.snapshot.paramMap.get('id'));
  readonly details = toSignal(this.service.get(this.serviceProviderId), { initialValue: null });

  readonly typeLabel = computed(() => {
    const t = this.details()?.type;
    if (t === ServiceProviderType.Nhf) return 'NFZ';
    if (t === ServiceProviderType.Private) return 'Prywatny';
    return t ?? '-';
  });

  readonly typeColor = computed(() => {
    const t = this.details()?.type;
    if (t === ServiceProviderType.Nhf) return 'blue';
    if (t === ServiceProviderType.Private) return 'green';
    return 'default';
  });

  readonly address = computed(() => {
    const d = this.details();
    if (!d) return '-';
    const parts = [d.street, [d.zip, d.place].filter(Boolean).join(' ')].filter(Boolean);
    return parts.join(', ') || '-';
  });
}
